export default __webpack_public_path__ + "static/media/2507101.c2dc2398.png";